import axios from 'axios';
import { config } from './config';

const lovageApi = axios.create({
  baseURL: config.lovage.apiUrl,
  headers: {
    'Content-type': 'application/json',
  },
});

let tokenGenerator: null | (() => Promise<string>) = null;

const setTokenGenerator = (generator: () => Promise<string>) => {
  tokenGenerator = generator;
};

const getToken = async () => {
  if (tokenGenerator) {
    return tokenGenerator();
  }
  return null;
};

// Intercepts each request and adds the token to the header
lovageApi.interceptors.request.use(
  async (config) => {
    const bearerToken = await getToken();

    if (bearerToken) {
      config.headers = {
        Authorization: `Bearer ${bearerToken}`,
      };
    }

    return config;
  },
  (error) =>
    // Do something with request error
    Promise.reject(error)
);

export { lovageApi, setTokenGenerator };
